import {
    requestResponsesItem,
    allowForwardingItem,
    responseOptionsButtonLabel,
    hideAttendeesItem,
} from './getResponseOptions.locstring.json';
import loc from 'owa-localize';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

import { CalendarIcons } from 'owa-calendar-icons';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import type { IContextualMenuItem } from '@fluentui/react/lib';
import { isEventInstanceOfSeries } from 'owa-calendar-event-capabilities';

import {
    onRequestResponseChanged,
    onAllowForwardingChanged,
    onHideAttendeeListChanged,
} from 'owa-calendar-compose-form-actions';

const getResponseOptionsMenuItems = (item: CalendarEvent): IContextualMenuItem[] => [
    {
        key: 'requestResponse',
        name: loc(requestResponsesItem),
        canCheck: true,
        checked: item.IsResponseRequested,
        onClick: () => {
            onRequestResponseChanged(!item.IsResponseRequested);
        },
    },
    {
        key: 'allowForwarding',
        name: loc(allowForwardingItem),
        canCheck: true,
        checked: !item.DoNotForwardMeeting,
        onClick: () => {
            onAllowForwardingChanged(item.DoNotForwardMeeting);
        },
        disabled: isEventInstanceOfSeries(item),
    },
    {
        key: 'hideAttendeeList',
        name: loc(hideAttendeesItem),
        canCheck: true,
        checked: item.HideAttendees,
        onClick: () => {
            onHideAttendeeListChanged(!item.HideAttendees);
        },
        disabled: isEventInstanceOfSeries(item),
    },
];

export const getResponseOptions = (
    item: CalendarEvent,
    disabled?: boolean,
    onDismissContextMenu?: () => void
): FilterableMenuItem =>
    new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(responseOptionsButtonLabel),
        [FilterableMenuItemArgs.icon]: CalendarIcons.ResponsesMenu,
        [FilterableMenuItemArgs.disabled]: disabled,
        [FilterableMenuItemArgs.menuContent]: {
            items: getResponseOptionsMenuItems(item),
            onDismiss: onDismissContextMenu,
        },
        [FilterableMenuItemArgs.key]: 'ResponseOptions',
    });
